import React, { useContext, useState } from "react";
// import AuthHelperMethods from "./AuthHelperMethods";
import { MyContext, ListContext } from "./MyContext";

import { useHistory } from "react-router-dom";

import { ButtonOrangeInverse } from "./formComponents";
import posthog from "posthog-js";

//import LogoutConfirm from "./logoutConfirm";
import Auth from "./Auth";

const Logout = (e) => {
  const { mystate, dispatch } = useContext(MyContext);
  const { listState, dispatch2 } = useContext(ListContext);
  let history = useHistory();
  let [go, setGo] = useState(false);
  const logOut = () => {
    Auth.setToken("");
    dispatch({ type: "RESET_STATE" });
    dispatch2(["RESET_STATE"]);
    posthog?.reset();
    history.push("/login");
  };

  return <ButtonOrangeInverse onClick={() => logOut()} label={"Logout"} />;
};

export default Logout;
